<script lang="ts" setup>

  const props = defineProps<{
    formPosition: string[],
    backgroundColor: string,
    showSocialMediaIcons: boolean,
    textColors: {
      titleColor: string,
      bodyColor: string,
      iconTitleColor: string,
      iconColor: string,
      iconBackgroundColor: string
    },
    bgOnMobile?: boolean
  }>();

  const contactUsForm: any = await useAcfOptions('contact_form');

  let infoTitleColor = props?.textColors?.titleColor;
  let infoTextColor = props?.textColors?.bodyColor;

  const form: any = await useForm(`${contactUsForm?.contact_form_id}`);
  const socialMediaLinks: any = await useAcfOptions('social_media_links');

  const route = useRoute();
  let overflowClass = '';
  let style = '';
  if (route.path.toString() === '/') {
    overflowClass = 'bg-on-mobile';
  } else if (route.path.toString() === '/about-us' || route.path.toString() === '/about-us/' || props?.bgOnMobile) {
    overflowClass = 'bg-on-mobile-dark';
  }
</script>
<template>
  <div :class="`container-xl contact-form-div-wrapper ${overflowClass}`" :style="`${style}`">
    <div :style="`background-color:${props?.backgroundColor}`"
     :class="`contact-form-div container-xl d-flex flex-column-reverse ${props?.formPosition[0] === 'right' ? 'flex-md-row-reverse' : 'flex-md-row'}`">
      <div v-if="props?.showSocialMediaIcons" class="social-icons flex-column d-md-none d-flex">
        <h5 :style="`color:${textColors?.iconTitleColor}`">Connect with us</h5>
        <div class="d-flex icon-links">
          <template v-for="link in socialMediaLinks">
            <a :href="link?.url" class="ms-4" target="_blank" :aria-label="link?.name">
              <span class="d-flex align-items-center justify-content-center rounded-circle bg-secondary icon-circle icon-circle-light" :style="`background-color: ${textColors?.iconBackgroundColor} !important`">
                <Icon size="30px" :name="link?.icon_name" :style="`background-color: ${textColors?.iconColor} !important`"/>
              </span>
            </a>
          </template>
        </div>
      </div>
      <div class="form-section col-md-8 mt-md-0 mt-5">
        <GravityForm :formObj="form" formId="contactus-form" :gravityFormId="contactUsForm?.contact_form_id"/>
      </div>
      <div :class="`info-section col-md-4 pt-5 ${props?.formPosition[0] === 'right' ? 'pe-md-5' : 'ps-md-5'} ps-0 d-flex flex-column justify-content-between`">
        <div>
          <h1 class="mb-4 title" :style="`color:${infoTitleColor}`">{{ contactUsForm?.contact_form_title }}</h1>
          <div :style="`color:${infoTextColor}`" v-html="contactUsForm?.contact_form_description"></div>
        </div>  
        <div v-if="props?.showSocialMediaIcons" :class="`social-icons flex-column d-none d-md-flex`">
          <h5 class="social-media-title" :style="`color:${textColors?.iconTitleColor}`">Connect with us</h5>
          <div class="d-flex icon-links">
            <template v-for="link in socialMediaLinks">
              <a v-if="link?.show_in_footer" :href="link?.url" class="ms-4" target="_blank" :aria-label="link?.name">
                <span class="d-flex align-items-center justify-content-center rounded-circle bg-secondary icon-circle icon-circle-light" :style="`background-color: ${textColors?.iconBackgroundColor} !important`">
                  <Icon size="30px" :name="link?.icon_name" :style="`background-color: ${textColors?.iconColor} !important`"/>
                </span>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>